import $ from 'jquery';
window.addEventListener('px-ready', function () {
    initPopoverSearch();
});

function initPopoverSearch() {
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
    $('.js-open-searchform').click(function (e) { e.preventDefault();$('body').addClass('popover-search-open'); $('.search-autocomplete').focus();})
    $('.px-popover-search').click(function (e) {
        var $target = $(e.target);
        if ($target.is('.js-close-searchform') || $target.parents('.uk-container').length == 0) {
            e.preventDefault(); $('body').removeClass('popover-search-open');
        }
    })
    $('.js-close-searchform').click(function(e){
        e.preventDefault(); $('body').removeClass('popover-search-open');
    })
    $('.m-popover-search').on('click', function (e) {
        if ($(e.target).hasClass('m-popover-search')) {
            $('body').removeClass('popover-search-open');
        }
    });
    var xhr;
    $('.search-autocomplete').on('change keyup', function () {
        var val = $(this).val(), $form = $(this).parents('form');
        if (val.length > 2) {
            if (xhr) {
                xhr.abort();
                xhr = null;
            }
            xhr = $.get($form.data('ajaxAction'), {s: val}).done(function(data) {
                if ($.trim(data).length > 1) {
                    $('.searchcontainer').addClass('has-matches');
                    $('.autocomplete-suggestions').addClass('has-matches').html(data);
                    $('.autocomplete-suggestions a').on('click', function () {$('body').removeClass('popover-search-open');});
                } else {
                    $('.searchcontainer').removeClass('has-matches');
                    $('.autocomplete-suggestions').removeClass('has-matches');
                }
            });            
        }
    });
}
